import { fromJS } from 'immutable';

export default {
    setProjects: (state, projects) => {
        return state.setIn(['list'], fromJS(projects)).set('initialized', true);
    },
    setProject: (state, project) => {
        return state.setIn(['list'], fromJS(project));
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/Projects/core.js